import React from 'react'

export const LoadingPage = () => {
  return (
    <div>LoadingPage</div>
  )
}
